import classNames from 'classnames/bind';
import Message from 'mcs-toolkit/components/Message';
import React from 'react';

import styles from './_BasicFieldError.css';

const css = classNames.bind(styles);

type Props = {
    children: React.ReactNode | string;
    className?: string;
    dataTest: string;
};

export const _BasicFieldError = ({ children, className, dataTest }: Props) => {
    return (
        <Message
            error
            size="mini"
            className={css('message', className)}
            data-test={dataTest}
        >
            {typeof children === 'object' ? (
                children
            ) : (
                <div
                    // innerHtml to get links directly from error generator lib
                    dangerouslySetInnerHTML={{
                        __html: children as any,
                    }}
                />
            )}
        </Message>
    );
};
